import { gql } from 'urql';

export const mutationRemoveWorkflowInput = gql`
  mutation RemoveWorkflowInput($versionId: String!, $paramId: String!) {
    removeWorkflowInput(versionId: $versionId, inputParameterId: $paramId) {
      id
    }
  }
`;
